import React from 'react';
import { Box, Modal } from '@mui/material';
import { LoaderContainer, StyledCircularProgress, StyledFilledCircularProgress, StyledIcon } from '@components/loader/loader.styles';
import { Icon } from '@elements';
import LogoBig from '@images/logo-big.svg';
import washer from '@images/washer.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InlineLoader = function InlineLoader() {
  return /*#__PURE__*/_jsxs(LoaderContainer, {
    children: [/*#__PURE__*/_jsx(StyledIcon, {
      src: LogoBig,
      width: 60,
      height: 60
    }), /*#__PURE__*/_jsx(Icon, {
      src: washer,
      width: 118,
      height: 118
    }), /*#__PURE__*/_jsx("svg", {
      width: "0",
      height: "0",
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_1187_12932",
        x1: "116.501",
        y1: "88.5",
        x2: "67.5009",
        y2: "120.5",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#414141"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#414141",
          stopOpacity: "0"
        })]
      })
    }), /*#__PURE__*/_jsx(StyledFilledCircularProgress, {
      disableShrink: true,
      thickness: 1.5,
      sx: {
        scale: '-1 1'
      }
    }), /*#__PURE__*/_jsx("svg", {
      width: "0",
      height: "0",
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "linearColors",
        x1: "23.1834",
        y1: "55.7664",
        x2: "22.8814",
        y2: "99.8845",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF5100"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FF5100",
          stopOpacity: "0"
        })]
      })
    }), /*#__PURE__*/_jsx(StyledCircularProgress, {
      disableShrink: true,
      thickness: 3
    })]
  });
};

var LoaderView = function LoaderView(_ref) {
  var isShowLoader = _ref.isShowLoader;
  return /*#__PURE__*/_jsx(Modal, {
    role: "progressbar",
    disableEnforceFocus: true,
    disableAutoFocus: true,
    disableEscapeKeyDown: true,
    open: isShowLoader,
    "aria-labelledby": "loader",
    closeAfterTransition: true,
    sx: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      backdropFilter: 'blur(6px)',
      '.MuiBackdrop-root': {
        backgroundColor: 'transparent'
      }
    },
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        outline: 'none'
      },
      children: /*#__PURE__*/_jsx(InlineLoader, {})
    })
  });
};

export { InlineLoader, LoaderView };